import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class MerchantsIdolAuditByDayAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['idolBusiness', {
            url: '/admin/shop/ktvBusinessDetail',
            name: 'list',
            label: '列表'
        }],
        ['exportExcelMerchantIdolAuditList', {
            url: '/admin/shop/exportKtvBusinessDetail',
            name: 'export-excel',
            label: '导出'
        }],

    ])
    // 棋牌营收列表
    public idolBusiness(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('idolBusiness').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    // 导出棋牌营收列表
    public exportExcelMerchantIdolAuditList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('exportExcelMerchantIdolAuditList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }
}